export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/pets/index/resources/computed.js